<div class="bl-max-width--tablet-width bl-margin-x--auto" data-automation-id="generic-error-card">
  <div class="bl-block-module bl-font-color--base bl-padding--16 bl-padding-lg--48 bl-margin--24 bl-margin-lg--0 bl-margin-y-lg--48">
    <header class="bl-text-align--center bl-margin-bottom--48">
      <h1 class="bl-font-size--22 bl-font-weight--900 bl-font-color--black">
        {{ 'genericError/heading' | dictionary }}
      </h1>
      <img
        src="/assets/images/opps-error-icon.svg"
        alt="icon of yellow page with exclamation mark in the center"
        class="bl-margin-y--16 bl-margin-y-md--24"
      />
      <p class="bl-font-size--18 bl-font-weight--900 bl-font-color--black">
        {{ 'genericError/subheading' | dictionary }}
      </p>
    </header>
    <ecp-lender-contact-blocks *ngIf="lenderConfig" [lenderData]="lenderConfig"></ecp-lender-contact-blocks>
  </div>
</div>
